import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { FuseFullscreenModule } from '@fuse/components/fullscreen/fullscreen.module';
import{EntityModule} from 'app/shared/entity/entity.module';
import { ShortcutsModule } from 'app/layout/common/shortcuts/shortcuts.module';

@NgModule({
  declarations: [
    FooterComponent
  ],
  imports: [
    CommonModule,MatIconModule,MatTooltipModule,FuseFullscreenModule,EntityModule,ShortcutsModule
  ],
  exports:[FooterComponent]
})
export class FooterModule { }
